<template>
  <v-card flat class="transparent">
    <v-card-text>
      <editable-field field-id="company_info" v-if="fields"></editable-field>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  computed: {
    fields() {
      return this.$store.getters.fields;
    }
  }
};
</script>

<style>
</style>
